// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, clsx, Icon } from '@a-type/ui';
export function TagToggle({ name, icon, color, className, onToggle, toggled, }) {
    return (_jsxs(Button, { size: "small", color: "primary", className: clsx('flex items-center gap-1 [font-weight:inherit] text-xs', color && `theme-${color}`, className), toggled: toggled, onClick: onToggle, children: [_jsx("span", { children: _jsx(Icon, { name: icon || 'tag', className: "w-10px h-10px" }) }), _jsx("span", { children: name })] }));
}
//# sourceMappingURL=TagToggle.js.map